import React from "react";
import { makeStyles,CardMedia,Box,Typography,Grid,Card,CardContent} from "@material-ui/core";
import PropTypes from "prop-types"

const useStyles = makeStyles({
    cardContent: {
      transition: 'transform 0.3s ease-in-out',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
  });

export default function AvailableSpace(props) {
    const classes = useStyles();
    return (
        <>
        <Grid item xs={12} sm={6} md={4}>
        <Card variant="outlined" className={classes.cardContent}
            sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
        >
            
            <CardMedia
            component="img"
            sx={{
                // 16:9
                pt: '56.25%',
            }}
            image={props.item.imageSrc}
            />
            
            <CardContent sx={{ flexGrow: 1 }}>
            <Typography gutterBottom variant="h5" component="h2">
            {props.item.title}
            </Typography>
            <Typography>
            {props.item.spaceType}
            </Typography>
            </CardContent>
            
            <Box sx={{display: 'flex', gap:(30), alignItems:'center', pl:2, pb:1}}>
                <Typography variant="h6">
                {props.item.price}
                </Typography>
                <Typography variant="h6">
                {props.item.size}
                </Typography>
            </Box>
        </Card>
        </Grid>
        </>
    );
}

AvailableSpace.propTypes = {
    title: PropTypes.string.isRequired,
    spaceType: PropTypes.string.isRequired,
    price: PropTypes.string,
    size: PropTypes.string,
    imageSrc: PropTypes.string.isRequired
}